import SendSolicitation from './SendSolicitation';

export default SendSolicitation;



// WEBPACK FOOTER //
// ./src/components/Modals/sendSolicitations/index.jsx